import { AuthModel, LoginRequest, UserModel } from './type';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/me`;
export const LOGIN_URL = `${API_URL}/auth/login`;
export const REFRESH_URL = `${API_URL}/auth/refresh`;
export const LOGOUT_URL = `${API_URL}/auth/logout`;
export const FORGOT_PASSWORD_URL = `${API_URL}/auth/forgot-password`;
export const RESET_PASSWORD_URL = `${API_URL}/auth/reset-password`;

// Server should return AuthModel
export function login(request: LoginRequest) {
  return axios.post<{ data: AuthModel; message: string; statusCode: number }>(LOGIN_URL, request);
}

// Exchanges the httpOnly refresh cookie for a new in-memory access token. Cookies are sent
// automatically (withCredentials); the CSRF header is attached by the request interceptor.
export function refresh() {
  return axios.post<{ data: AuthModel; message: string; statusCode: number }>(REFRESH_URL, {});
}

// Server-side logout: revokes the refresh token and clears the auth cookies. Requires the
// current (in-memory) access token, so call this before clearing client auth state.
export function logout() {
  return axios.post<{ data: string; message: string; statusCode: number }>(LOGOUT_URL, {});
}

export function getUserByToken(token: string) {
  return axios.get<{ data: UserModel }>(GET_USER_BY_ACCESSTOKEN_URL, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function forgotPassword(email: string) {
  return axios.post<{ data: AuthModel; message: string; statusCode: number }>(FORGOT_PASSWORD_URL, {
    email,
  });
}
export function resetPassword(password: string, token: string) {
  return axios.post<{ data: AuthModel; message: string; statusCode: number }>(RESET_PASSWORD_URL, {
    password,
    token,
  });
}
